import { application } from "../../app"

import AccountsQualificationInProgressController from "./accounts/qualification/in_progress_controller"
application.register("accounts--qualification--in-progress", AccountsQualificationInProgressController)

import AccountsQualificationSidebarController from "./accounts/qualification/sidebar_controller"
application.register("accounts--qualification--sidebar", AccountsQualificationSidebarController)

import AccountsQualificationUrlSearcherController from "./accounts/qualification/url_searcher_controller"
application.register("accounts--qualification--url-searcher", AccountsQualificationUrlSearcherController)

import AccountsQualificationWebsiteProjectController from "./accounts/qualification/website_project_controller"
application.register("accounts--qualification--website-project", AccountsQualificationWebsiteProjectController)

import AccountsFormController from "./accounts/form_controller"
application.register("accounts--form", AccountsFormController)

import BusinessServicesDealsPaymentConfigurationController from "./business_services/deals/payment_configuration_controller"
application.register("business-services--deals--payment-configuration", BusinessServicesDealsPaymentConfigurationController)

import BusinessServicesLearningProjectsFundingProviderController from "./business_services/learning_projects/funding_provider"
application.register("business-services--learning-projects--funding-provider", BusinessServicesLearningProjectsFundingProviderController)

import BusinessServicesLearningProjectsProgramDatesConstraintsController from "./business_services/learning_projects/program_dates_constraints"
application.register("business-services--learning-projects--program-dates-constraints", BusinessServicesLearningProjectsProgramDatesConstraintsController)

import BusinessServicesLocationDealPropositionFunnelDiscountsDefinitionController from "./business_services/location/deal/proposition_funnel/discounts_definition_controller"
application.register("business-services--location--deal--proposition-funnel--discounts-definition", BusinessServicesLocationDealPropositionFunnelDiscountsDefinitionController)

import BusinessServicesLocationDealPropositionFunnelCrmSynchronizationController from "./business_services/location/deal/proposition_funnel/crm_synchronization_controller"
application.register("business-services--location--deal--proposition-funnel--crm-synchronization", BusinessServicesLocationDealPropositionFunnelCrmSynchronizationController)

import BusinessServicesWebsiteLoomVideoGifFetcherController from "./business_services/website/loom_video_gif_fetcher"
application.register("business-services--website--loom-video-gif-fetcher", BusinessServicesWebsiteLoomVideoGifFetcherController)

import InteractionsManagerInteractionVideoCallsFormController from "./interactions_manager/interaction_video_calls/form_controller"
application.register("interactions-manager--interaction-video-call--form", InteractionsManagerInteractionVideoCallsFormController)

import WhiteSpacesLibraryArticlesSectionsController from "./white_spaces/library/articles/sections_controller"
application.register("white-spaces--library--articles--sections", WhiteSpacesLibraryArticlesSectionsController)

import AILabPromptProjectsFormController from "./ai/lab/prompt_projects/form_controller"
application.register("ai--lab--prompt-projects--form", AILabPromptProjectsFormController)

import BusinessServicesLearningProjectsProgressSliderController from "./business_services/learning_projects/progress_slider_controller"
application.register("business-services--learning-projects--progress-slider", BusinessServicesLearningProjectsProgressSliderController)

import SslActivationStatusController from "./ssl_activation/status_controller"
application.register("ssl-activation--status", SslActivationStatusController)
